import type { UserProfile } from '../services/firestore';

/**
 * Shopify App Store installs: merchants are authenticated via Shopify OAuth / Admin.
 * Privy-style apps skip a separate email passcode step; we trust the contact email they confirm
 * and mark our custom verification record (see AccountStep).
 */
export function shouldSkipEmailVerificationForShopifyInstall(
  profile: UserProfile | null | undefined
): boolean {
  if (!profile) return false;
  if (profile.emailTrustedViaShopify === true) return true;
  if (
    profile.billingSource === 'shopify' &&
    profile.shopifyInstallWizardCompleted === true
  ) {
    return true;
  }
  return false;
}
